<header class="wrapper bg-light">
  <div class="navbar-container">
    <nav class="navbar navbar-expand-lg classic transparent navbar-light">
      <div class="container flex-lg-row flex-nowrap align-items-center">
        
        <div class="navbar-brand w-100">
          <a href="./index.html">
            <img class="logo-dark" src="assets/img/logo.png" alt="Autoverse Logo" />
          </a>
        </div>

        <!-- Show Home link instead of toggler in mobile view -->
        <a class="nav-link d-lg-none text-dark" href="./index.html">Home</a>

        <div class="navbar-collapse offcanvas offcanvas-nav offcanvas-start">
          <div class="offcanvas-header d-lg-none">
            <h3 class="text-white fs-30 mb-0">Autoverse</h3>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div class="offcanvas-body ms-lg-auto d-flex flex-column h-100">
            <ul class="navbar-nav">
              <li class="nav-item">
                <a class="nav-link" href="./index.html">Home</a>
              </li>
              <!-- <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="aboutUsDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">Why Autoverse</a>
                <ul class="dropdown-menu" aria-labelledby="aboutUsDropdown">
                <li><a class="dropdown-item" href="#expand-your-reach">Expand Your Reach</a></li>
                <li><a class="dropdown-item" href="#unlock-full-potential">Unlock Full Potential</a></li>
                <li><a class="dropdown-item" href="#garage-partner-benefits">Garage and Partner Benefits</a></li>
                <li><a class="dropdown-item" href="#unmatched-benefits">Unmatched Benefits</a></li>
                </ul>
              </li>
              <li class="nav-item">
                <a class="nav-link scroll" href="#key-offerings">Key Offerings</a>
              </li> -->
            </ul>
          </div>
        </div>

      </div>
    </nav>
  </div>
</header>
